export default class AppBrowser {

  static isMobile() { 
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
       return true
     }
    else {
       return false
     }
  }

  static openNewTab(url, fileName) {

    if (!fileName)
      fileName = "_blank"
    
    window.open(url, fileName)
    window.focus()
  }

  static setBeforeUnloadValidation() {
    
    window.onbeforeunload = () => {      

      if (!event) 
        event = window.event
      
      event.cancelBubble = false
      event.returnValue = "Deseja realmente sair dessa pagina ?"

      if (event.stopPropagation) {
        event.stopPropagation()
        event.preventDefault()
      }
    }
  }

  static removeBeforeUnloadValidation() {
    window.onbeforeunload = null
  }
}